import React from "react";
import { motion } from "framer-motion";

const values = [
    {
        icon: (
            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        title: "Integrity",
        description: "We operate with complete honesty and transparency in all our dealings.",
    },
    {
        icon: (
            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        title: "Efficiency",
        description: "Time matters in immigration cases. We work quickly and efficiently.",
    },
    {
        icon: (
            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
        ),
        title: "Compassion",
        description: "We understand that immigration processes can be overwhelming.",
    },
    {
        icon: (
            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
        ),
        title: "Reliability",
        description: "You can count on us to be there when you need us most.",
    },
];

export default function ValuesSection() {
    return (
        <section className="py-24 bg-gradient-to-b from-white to-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">What We Stand For</h2>
                    <p className="mt-3 text-gray-600">Principles that shape every client interaction.</p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                    <div className="lg:col-span-2">
                        <ul className="space-y-6">
                            {values.map((v, i) => (
                                <motion.li key={i} className="relative ps-10" whileHover={{ x: 4 }}>
                                    <span className="absolute left-0 top-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 text-white ring-4 ring-blue-100">
                                        {v.icon}
                                    </span>
                                    <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
                                        <h3 className="text-xl font-bold text-gray-900">{v.title}</h3>
                                        <p className="mt-2 text-gray-600">{v.description}</p>
                                    </div>
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-1">
                        <div className="sticky top-24 rounded-2xl border border-blue-200/60 bg-gradient-to-br from-blue-50 to-cyan-50 p-6 shadow-sm">
                            <h4 className="text-lg font-semibold text-blue-900">Client Promise</h4>
                            <p className="mt-2 text-blue-900/80">Clear timelines, transparent pricing, and a real person who knows your case.</p>
                            <div className="mt-4 flex items-center gap-2 text-sm text-blue-800">
                                <svg className="w-[20px] h-[20px]" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                No hidden fees
                            </div>
                            <div className="mt-1 flex items-center gap-2 text-sm text-blue-800">
                                <svg className="w-[20px] h-[20px]" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                Live status updates
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}